import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  white?: boolean;
  checked?: boolean;
  labelFontSize?: string;
}

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: ${props => props.labelFontSize || "16px"};
  font-family: ${theme.fontFamily.regular};
  color: ${theme.color.primary};
  ${({ white }: IProps) =>
    white
      ? `
        align-items: flex-start;`
      : ``}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  margin-right: ${props => props.labelFontSize || "10px"};
  min-width: 40px;
  min-height: 40px;
  border: 1px solid ${theme.color.primary};
  color: ${theme.color.primary}
    ${({ white }: IProps) =>
      white
        ? `background:${theme.color.white};
        align-items: flex-start;
      margin-bottom: 30px;
      `
        : ``}
    ${({ checked }: IProps) =>
      checked
        ? `
      border: 1px solid ${theme.color.white};
      background: ${theme.color.tertiary};
    `
        : ``};
`;

export const LabelSpan = styled.span`
  text-align: justify;
`;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/Checkbox.style.tsx